import buoyTheme from "buoy-theme"
import { setterReducer } from "../common/redux"
import * as t from "./actionTypes"

export const custom = setterReducer({}, t.GET_CUSTOM_SUCCESS)

export const brand = (state = {}, action) => {
  switch (action.type) {
    case t.GET_BRAND_SUCCESS:
      return action.payload
    case t.UPDATE_BRAND_GATING:
      return { ...state, gated: action.payload }
    case t.SET_TERMS_AGREED:
      return { ...state, termsAgreed: action.payload }
    default:
      return state
  }
}

const getVisitTheme = themeAreas => {
  let colors = {}
  if (themeAreas.visit_chat && themeAreas.visit_chat.colors) {
    const chatColors = themeAreas.visit_chat.colors
    Object.keys(chatColors).forEach(key => {
      let transformedName = key
      const i = transformedName.indexOf("_")
      if (i !== -1) {
        transformedName =
          transformedName.slice(0, i) +
          transformedName.slice(i + 1, i + 2).toUpperCase() +
          transformedName.slice(i + 2)
      }
      colors[transformedName] = chatColors[key].value
    })
  }

  return colors
}

export const theme = (state = buoyTheme, action) => {
  switch (action.type) {
    case t.SET_THEME:
      return action.payload
    case t.GET_BRAND_SUCCESS:
      const visitTheme = getVisitTheme(action.payload)
      return { ...state, colors: { ...state.colors, ...visitTheme } }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./assets/embed/reducer.js